import { AsButton, Header } from '@adserve/adserve-react-components';
import React, { useContext, useState } from 'react';
import { SystemSettingsContext } from '../../../contexts/SystemSettingsContext';
import { BusinessTypes } from '../../../constants/Enums';
import { UpdateCampaign } from '../../../services/CampaignsDataService';
import { AirtimePlanningContext } from '../../../contexts/AirtimePlanningContext';

const AirtimeBurstPropertiesPanel = ({ campaign, campaignBursts, readOnly }) => {
    const { formatCurrency } = useContext(SystemSettingsContext);
    const { propertyStats } = useContext(AirtimePlanningContext);
    const g = campaign.campaignGoal.find((s) => s.selected);
    const [burstBudget, setBurstBudget] = useState(g.value);

    const usedBudget = campaignBursts.reduce((a, b) => {
        return a + b.spendDiscounted;
    }, 0);

    const newBurst = async () => {
        await UpdateCampaign(campaign, propertyStats).then((res) => {
            window.open(
                `${window.origin}/campaign-manager/campaigns/create?campaignId=${campaign.id}&burstId=${
                    window.emptyGuid
                }&businessType=${encodeURIComponent(BusinessTypes.AIRTIMEBURST.name)}&readOnly=false`,
                '_blank'
            );
        });
    };

    return (
        <div
            style={{
                display: 'grid',
                gridTemplateColumns: 'max-content auto max-content'
            }}
        >
            <div style={{ display: 'flex', alignItems: 'flex-start', marginTop: 16 }}>
                <div
                    style={{
                        width: '100%',
                        display: 'grid',
                        gridTemplateColumns: '198px 198px',
                        height: 40,
                        overflowY: 'hidden',
                        marginTop: 5
                    }}
                >
                    <Header
                        rowHeight={40}
                        style={{
                            borderLeftWidth: 1,
                            fontSize: 15,
                            justifyContent: 'flex-start',
                            backgroundColor: '#F7F7F7'
                        }}
                    >
                        {window.translate('Total Airtime Budget:')}
                    </Header>
                    <Header style={{ justifyContent: 'flex-end' }}>{formatCurrency(Math.round(burstBudget, 0))}</Header>
                </div>
                <div
                    style={{
                        width: '100%',
                        display: 'grid',
                        gridTemplateColumns: '198px 198px',
                        height: 40,
                        overflowY: 'hidden',
                        marginTop: 5,
                        marginLeft: 40
                    }}
                >
                    <Header
                        rowHeight={40}
                        style={{
                            borderLeftWidth: 1,
                            fontSize: 15,
                            justifyContent: 'flex-start',
                            backgroundColor: '#F7F7F7'
                        }}
                    >
                        {window.translate('Total Remaining:')}
                    </Header>
                    <Header style={{ justifyContent: 'flex-end' }}>
                        {formatCurrency(Math.round(burstBudget - usedBudget, 0))}
                    </Header>
                </div>
            </div>
            <div id='airtime-bursts-placeholder' />
            <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                <AsButton
                    id='airtime-bursts-new-btn'
                    handleClick={newBurst}
                    disabled={readOnly || burstBudget - usedBudget === 0}
                    style={{
                        fontWeight: 'bold',
                        fontSize: 15,
                        height: 40,
                        width: 130,
                        gridRow: 'span 2',
                        marginLeft: 20
                    }}
                >
                    {window.translate('Add New')}
                </AsButton>
            </div>
        </div>
    );
};

export default AirtimeBurstPropertiesPanel;
